import React from "react";
import {Row, Anchor} from "antd";
import { Link } from 'react-router-dom';
import {scrollToTop} from "../../Utils/CommonFunc";
export default class MyCard extends React.Component {
    render() {
        const { imageUrl, title, content } = this.props;
        return (
            <Row type="flex" justify="center">
              <Link to={{ pathname: '/industrySolutions' , state: { name: title }}}>
                  <div className='caseBlock'>
                      <Row type="flex" justify="center" style={{padding:'45px 25px 20px'}}>
                          <img src={imageUrl} alt='picture' height="181" style={{borderRadius:'8px 8px 0 0'}}/>
                      </Row>
                      <div style={{padding:'20px 25px'}}>
                          <div style={{padding:'0 0 10px',fontSize:20,textAlign:'center',color:'rgba(0, 0, 0, 0.85)'}}>{title}</div>
                          {/*<div style={{color:'#919191'}}>{content}</div>*/}
                      </div>
                  </div>
              </Link>
            </Row>
        );
    }
}